module.exports = __webpack_public_path__ + "static/available-for-labeled-f6e1528d54c1c3eb3202c5b161bd3feb.png";